<script setup lang="ts">
import './assets/style.scss'
import { useModel } from './../model/model'
import { useSendForm } from './../model/api'

const { data } = useModel()
const { sendForm, isPending } = useSendForm()
</script>

<template>
  <div class="user-alerts__form">
    <span>{{ $t('itf.notifications') }}:</span>

    <VCheckbox
      class="user-alerts__switch"
      :label="$t('itf.acoustic')"
      :disabled="isPending"
      hide-details
      density="compact"
      v-model="data.notify_audio"
      @change="sendForm(data)"
    />

    <VCheckbox
      class="user-alerts__switch"
      :label="$t('itf.pop_up')"
      :disabled="isPending"
      hide-details
      density="compact"
      v-model="data.notify_bubbles"
      @change="sendForm(data)"
    />
  </div>
</template>
